import { useQuery } from 'react-query'

import { get } from '../../utility/api'

const useWelcomeMessage = () => {
  return useQuery('welcome_message', ({ signal }) =>
    get('/welcome_message', {
      signal,
    })
  )
}

export default {
  getWelcomeMessage: useWelcomeMessage,
}
